import { createContext, useContext } from "react";

/**
 * Shell-level context: signed-in user, role, live-feed status and the scope registry.
 * Provided by App.js once the session is confirmed.
 */
export const AppContext = createContext(null);

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used inside the authenticated shell");
  return ctx;
};
